import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ArrowRight2, ArrowLeft2 } from "iconsax-react";
import { Button } from "@/shared/ui";
import { ACCOUNTING_WAREHOUSE_REQUESTS_PAGE_ROUTE } from "@/shared/utils";

interface Props {
  selectedGroup?: string | null;
  onBack?: () => void;
  pageTitle?: string;
  drilldownTitle?: string;
  extraButtons?: React.ReactNode;
}

export default function WarehouseHeader({ selectedGroup, onBack, pageTitle, drilldownTitle, extraButtons }: Props) {
  const { t } = useTranslation("WarehousePage");
  const navigate = useNavigate();

  const title = selectedGroup
    ? (drilldownTitle ?? t("headerInventory", { name: selectedGroup }))
    : (pageTitle ?? t("title"));

  return (
    <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5 pt-1 pr-1">
      <h1 className="text-display-xs content-base-primary">{title}</h1>
      {selectedGroup && onBack ? (
        <Button variant="secondary" size="lg" onClick={onBack}>
          <ArrowLeft2 size={16} color="currentColor" />
          {t("nav.backToWarehouse")}
        </Button>
      ) : (
        <div className="flex items-center gap-2">
          {extraButtons}
          <Button variant="secondary" size="lg" onClick={() => navigate(ACCOUNTING_WAREHOUSE_REQUESTS_PAGE_ROUTE)}>
            {t("nav.requests")}
            <ArrowRight2 size={16} color="currentColor" />
          </Button>
        </div>
      )}
    </div>
  );
}
